<template>
    <div class="flex items-start my-4">
        <div class="absolute flex items-center h-5">
            <input
                v-model="isChecked"
                type="checkbox"
                class="w-6 h-6 text-blue-600 transition duration-150 ease-in-out border-gray-500 shadow-md form-checkbox border-1"
            />
        </div>
        <div class="ml-8 text-sm leading-5 pl-7">
            <label for="comments" class="font-medium text-gray-700">{{
                label
            }}</label>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        },
        selectedValues: {
            type: Array
        }
    },
    mounted() {
        this.selectedValues.forEach(element => {
            if (this.label === element) {
                this.isChecked = true;
                this.$emit("checked", this.label);
            }
        });
    },
    data() {
        return {
            isChecked: false
        };
    },
    watch: {
        isChecked: function() {
            this.$emit("checked", this.label);
        }
    }
};
</script>

<style></style>
